import type { CartGetItem } from '../../types/cart';

// Exports print what the cart page shows; callers pass items whose Amazon record prices past the on-screen limit already fell back to the saved price.
// A missing price (stored as "-1", or blank) is null, since the page shows nothing for it.
export const exportedItemPrice = ({ price }: CartGetItem): number | null => {
  const amount = typeof price === 'number' ? price : Number.parseFloat(price ?? '');
  if (!(amount > 0)) return null;
  return typeof price === 'number' ? price : Number(amount.toFixed(2));
};

export const exportedItemTitle = ({ title }: CartGetItem): string => title || '--';
